import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../basic/footer.component';
import './auth.style.scss';

const AuthLayout = () => {
  return (
    <>
      <Outlet />
      <div className="authLayout__footer">
        <Footer />
      </div>
    </>
  );
};

export default AuthLayout;
